<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Active IoT Device</h4>
    </div>
    <div class="col-sm-3"></div>
</div>


<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <!-- <div class="row p-t-20"> 
					<div class="col-md-3">
                        <div class="form-group">
                            <label class="control-label">Select Date</label>
                            <input type="date" id="dateTime" name="dateTime" class="form-control">
                         </div>
                    </div>
                    <div style="margin-top: 30px;"  class="col-md-2">
                        <button type="button" class="btn btn-outline-info" (click)="ShowReport()">Submit</button>
                    </div>
                </div> -->
                <div class="row mb-3">
                    <div class="form-group col-md-4">
                        <label>Zone</label>
                        <ng-select [items]="filterZoneList" bindLabel="zone_name" bindValue="id"
                            placeholder="Select Zones" [multiple]="true" appendTo="body"
                            (change)="onFilterZoneChange($event)"
                            [(ngModel)]="filterZoneIds">
                        </ng-select>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Ward</label>
                        <ng-select [items]="filterWardList" bindLabel="ward_name" bindValue="id"
                            placeholder="Select Wards" [multiple]="true" appendTo="body"
                            (change)="onFilterWardChange($event)"
                            [(ngModel)]="filterWardIds">
                        </ng-select>
                    </div>
                    <!-- <div class="form-group col-md-4" style="margin-top: 15px;">
                        <button class="btn btn-outline-danger btn-sm" (click)="resetFilter()">Reset Filter</button>
                    </div> -->
                </div>
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                        class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Zone</th>
                                <th>Ward</th>
                                <th>Toilet ID</th>
                                <th>MoHUA (GTL ID)</th>
                                <th>Toilet Name</th>
                                <th>Device ID</th>
                                <th style="white-space: normal;">Address</th>
                                <!-- <th  style="width: 30px;">Persons</th> -->
                                <!-- <th >Totals</th> -->
                                <!-- <th>Water Level</th> -->
                                <!-- <th>Air Quality</th> -->
                                <!-- <th >Feedback</th> -->
                                <th>HO</th>
                                <th>CSI</th>
                                <th>Daroga</th>
                                <th>Updated</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of rowData; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{data.zone_name}}</td>
                                <td>{{data.ward_name}}</td>
                                <td style="white-space: normal;">{{data.toilet_no}}</td>
                                <td style="white-space: normal;">{{data.google_toilet_id}}</td>
                                <td style="white-space: normal;">{{data.toilet_name}}</td>
                                <td>{{data.device_id}}</td>
                                <td style="white-space: normal;">{{data.address}}</td>
                                <!-- <td >{{data.person_count}}</td>
                                <td >{{data.total_count}}</td> -->
                                <!-- <td>{{data.water_lavel}}</td> -->
                                <!-- <td >{{data.air_quality_index}}</td>
                                <td >{{data.feedback}}</td> -->
                                <td style="white-space: normal;">{{data.ho_name}}</td>
                                <td style="white-space: normal;">{{data.csi_name}}</td>
                                <td style="white-space: normal;">{{data.daroga_name}}</td>
                                <td>{{data.log_date_time}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>